import React from 'react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { AlertCircle } from 'lucide-react';
import { StatusOption, SideSelector } from './ExamFormControls';

const PainAssessmentSection = ({ formData, handleChange, readOnly }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 p-3 bg-[#C06144]/10 rounded-lg">
        <AlertCircle className="w-4 h-4 text-[#C06144]" />
        <span className="text-sm text-[#C06144]">
          Absent deep pain carries a poor prognosis in spinal cord disease.
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-3">
          <Label className="text-[#2A2C2A] font-medium">Superficial Pain</Label>
          <div className="flex gap-2 flex-wrap">
            <StatusOption
              value="present"
              label="Present"
              selected={formData.superficial_pain === 'present'}
              onChange={(v) => { handleChange('superficial_pain', v); handleChange('superficial_pain_side', ''); }}
              readOnly={readOnly}
            />
            <StatusOption
              value="absent"
              label="Absent"
              selected={formData.superficial_pain === 'absent'}
              onChange={(v) => handleChange('superficial_pain', v)}
              readOnly={readOnly}
            />
            <StatusOption
              value="unable_to_evaluate"
              label="U/E"
              selected={formData.superficial_pain === 'unable_to_evaluate'}
              onChange={(v) => { handleChange('superficial_pain', v); handleChange('superficial_pain_side', ''); }}
              readOnly={readOnly}
            />
          </div>
          <SideSelector field="superficial_pain" show={formData.superficial_pain === 'absent'} formData={formData} handleChange={handleChange} readOnly={readOnly} />
        </div>

        <div className="space-y-3">
          <Label className="text-[#2A2C2A] font-medium">Deep Pain</Label>
          <div className="flex gap-2 flex-wrap">
            <StatusOption
              value="present"
              label="Present"
              selected={formData.deep_pain === 'present'}
              onChange={(v) => { handleChange('deep_pain', v); handleChange('deep_pain_side', ''); }}
              readOnly={readOnly}
            />
            <StatusOption
              value="absent"
              label="Absent"
              selected={formData.deep_pain === 'absent'}
              onChange={(v) => handleChange('deep_pain', v)}
              readOnly={readOnly}
            />
            <StatusOption
              value="unable_to_evaluate"
              label="U/E"
              selected={formData.deep_pain === 'unable_to_evaluate'}
              onChange={(v) => { handleChange('deep_pain', v); handleChange('deep_pain_side', ''); }}
              readOnly={readOnly}
            />
          </div>
          <SideSelector field="deep_pain" show={formData.deep_pain === 'absent'} formData={formData} handleChange={handleChange} readOnly={readOnly} />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="hyperpathia" className="text-[#2A2C2A]">Hyperpathia Location</Label>
        <Textarea
          id="hyperpathia"
          value={formData.hyperpathia_location}
          onChange={(e) => handleChange('hyperpathia_location', e.target.value)}
          placeholder="Describe location if hyperpathia is noted on spinal palpation..."
          className="bg-[#F8F7F4] border-[#E5E4E0]"
          data-testid="hyperpathia-location"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="notes" className="text-[#2A2C2A]">Additional Notes</Label>
        <Textarea
          id="notes"
          value={formData.notes}
          onChange={(e) => handleChange('notes', e.target.value)}
          placeholder="Any additional observations or findings..."
          rows={4}
          className="bg-[#F8F7F4] border-[#E5E4E0]"
          data-testid="exam-notes"
        />
      </div>
    </div>
  );
};

export default PainAssessmentSection;
